"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneOf = exports.uint = exports.int = void 0;
const yup_1 = require("yup");
exports.int = (0, yup_1.number)().integer();
exports.uint = exports.int.positive();
const OneOf = (values) => {
    return (0, yup_1.mixed)().oneOf(values);
};
exports.OneOf = OneOf;
//# sourceMappingURL=base.js.map